export const TAGLINE = "Engineering Solutions • Reliable Systems • Professional Service";

export const CONTACT = {
    phones: [
        { display: "+91 90353 03716", href: "tel:+919035303716" },
        { display: "+91 97405 74060", href: "tel:+919740574060" },
    ],
    emails: [
        { display: "umaengineering166@gmail.com", href: "mailto:umaengineering166@gmail.com" },
        { display: "umareddy.naveen@gmail.com", href: "mailto:umareddy.naveen@gmail.com" },
    ],
    addressLines: [
        "No.2G-547/105, Sri Siddappaji Nilaya,",
        "Ward No.17, Opp. Bhagyalakshmi Store,",
        "Vinayakanagar, Hebbagodi,",
        "Bangalore - 560 099.",
    ],
    addressOneLine:
        "No.2G-547/105, Sri Siddappaji Nilaya, Ward No.17, Opp. Bhagyalakshmi Store, Vinayakanagar, Hebbagodi, Bangalore - 560 099.",
    mapsEmbed:
        "https://maps.google.com/maps?q=Hebbagodi%2C%20Bangalore%20560099&t=&z=15&ie=UTF8&iwloc=&output=embed",
    mapsLink: "https://www.google.com/maps/search/?api=1&query=Hebbagodi,+Bangalore+560099",
};

export const SERVICES = [
    {
        id: "mono-rail",
        name: "MONO RAIL",
        blurb: "Space-saving monorail systems engineered for smooth, controlled material movement along a fixed path.",
        description:
            "Engineered monorail lifting and handling systems for smooth, controlled material movement along a fixed path — ideal for stairwells, slopes and confined sites where conventional lifting cannot reach.",
        image:
            "https://static.prod-images.emergentagent.com/jobs/10189860-8b24-46f4-bd65-4597580438d9/images/788be505cd3faeeb01019cf1b292d99472f1519bb52c3ca693943b78df4f9000.jpeg",
    },
    {
        id: "bmu-system",
        name: "BMU SYSTEM",
        blurb: "Building Maintenance Units for safe, efficient access to high-rise facades.",
        description:
            "Building Maintenance Units designed for safe, efficient facade access — enabling cleaning, inspection and upkeep of modern high-rise structures with confidence.",
        image:
            "https://static.prod-images.emergentagent.com/jobs/10189860-8b24-46f4-bd65-4597580438d9/images/304c2fe86894cea461aa68ddad8f47c892b2a3ed53fbbee382f4a9d20fcc29e2.jpeg",
    },
    {
        id: "double-decker",
        name: "DOUBLE DECKER",
        blurb: "Dual-platform lifting that moves materials and crew between levels at the same time.",
        description:
            "Dual-platform lifting solutions that move materials and crew between levels at the same time — maximising productivity on busy construction sites.",
        image:
            "https://static.prod-images.emergentagent.com/jobs/10189860-8b24-46f4-bd65-4597580438d9/images/ac8f39bac2263fa9684712a0a9be69df94952a84de4c8781a92e4411fba8032d.jpeg",
    },
    {
        id: "tower-hoist",
        name: "TOWER HOIST",
        blurb: "Robust vertical hoisting for fast, secure transport of building materials.",
        description:
            "Robust vertical hoisting systems for fast, secure transport of building materials on construction sites — engineered for stability, uptime and everyday reliability.",
        image:
            "https://static.prod-images.emergentagent.com/jobs/10189860-8b24-46f4-bd65-4597580438d9/images/7cc035f52e635431f7717ed3f8472a71ab19c58da97657ebaee077df4cc2dafb.jpeg",
    },
    {
        id: "floor-crane",
        name: "FLOOR CRANE",
        blurb: "Compact, manoeuvrable cranes for precise lifting in workshops and tight spaces.",
        description:
            "Compact, manoeuvrable floor cranes for precise lifting and positioning of heavy loads inside workshops, factories and low-clearance spaces.",
        image:
            "https://static.prod-images.emergentagent.com/jobs/10189860-8b24-46f4-bd65-4597580438d9/images/775702221b617d44874095fc47ea27730c42aefb342b64b7959e5690f3a86a97.jpeg",
    },
    {
        id: "suspended-rope-platform",
        name: "SUSPENDED ROPE PLATFORM",
        blurb: "Stable suspended platforms for facade work at height — plastering, painting, glazing.",
        description:
            "Reliable suspended rope platforms for facade work at height — a stable, secure working platform for plastering, painting, glazing and building maintenance.",
        image:
            "https://static.prod-images.emergentagent.com/jobs/10189860-8b24-46f4-bd65-4597580438d9/images/06506ed98bd402312b888767e8ff4487a965a7498ce0c5201847cffb3d501a79.jpeg",
    },
];

export const HERO_IMAGE =
    "https://images.unsplash.com/photo-1485083269755-a7b559a4fe5e?auto=format&fit=crop&w=1920&q=80";
export const SERVICES_HEADER_IMAGE =
    "https://images.unsplash.com/photo-1567662591248-865b3397d4ae?auto=format&fit=crop&w=1920&q=80";
export const ABOUT_HEADER_IMAGE =
    "https://images.unsplash.com/photo-1516971849755-77ddd3e004b0?auto=format&fit=crop&w=1920&q=80";
export const FABRICATION_IMAGE =
    "https://static.prod-images.emergentagent.com/jobs/10189860-8b24-46f4-bd65-4597580438d9/images/39c90c375503cd96d3b00463993fd54760b48e50a576e15bc913402805102101.jpeg";
export const FACADE_IMAGE =
    "https://images.unsplash.com/photo-1512479373983-bd28a541041b?auto=format&fit=crop&w=1600&q=80";
export const WELDING_IMAGE =
    "https://images.unsplash.com/photo-1698664683348-f9f35b809821?auto=format&fit=crop&w=1600&q=80";

export const NAV_LINKS = [
    { label: "Home", path: "/", testid: "nav-link-home" },
    { label: "Our Services", path: "/services", testid: "nav-link-services" },
    { label: "About Us", path: "/about", testid: "nav-link-about" },
    { label: "Contact Us", path: "/contact", testid: "nav-link-contact" },
];
